import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import ExpenseCategoryService from "../../../services/expenses/expenseCategoryServices";

const EditExpenseCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [category_name, setCategory_name] = useState("");
  const [category_type, setCategory_type] = useState("Expense");
  const [isRecurring, setIsRecurring] = useState("No");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (!id) return;

    ExpenseCategoryService.getCategory(id)
      .then((res) => {
        const name = res?.data?.category_name || "";
        const type = res?.data?.category_type || "Expense";
        const nature = res?.data?.fee_nature || "";

        setCategory_name(name);
        setCategory_type(type);
        setIsRecurring(nature === "Recurring" ? "Yes" : "No");

        reset({
          categoryname: name,
        });
      })
      .catch(() => {
        toast.error("Failed to load category");
      });
  }, [id, reset]);

  const handleCancel = () => {
    navigate("/expense-categories");
  };

  const handleRegister = () => {
    setLoading(true);
    setDisable(true);

    const feeNature =
      category_type === "Fee"
        ? isRecurring === "Yes"
          ? "Recurring"
          : "One Time"
        : null;

    const payload = {
      category_name: category_name,
      category_type: category_type,
      fee_nature: feeNature,
    };

    ExpenseCategoryService.updateCategory(id, payload)
      .then(() => {
        toast.success("Category Updated Successfully");
        setTimeout(() => navigate("/expense-categories"), 1500);
      })
      .catch(() => {
        toast.error("Update Failed");
        setLoading(false);
        setDisable(false);
      });
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />

      <div className="content container-fluid">
        <h5>{t("Edit Category")}</h5>

        <h6>
          <Link to="/expense-categories" className="tc">
            {t("Categories")}
          </Link>{" "}
          / <span>{t("Edit Category")}</span>
        </h6>

        <form onSubmit={handleSubmit(handleRegister)}>
          <div className="form-group">
            <label>{t("Category Name")}</label>

            <input
              type="text"
              className="form-control"
              value={category_name}
              {...register("categoryname", {
                onChange: (e) => setCategory_name(e.target.value),
                required: true,
              })}
            />

            {errors.categoryname && (
              <div className="invalid-feedback d-block">
                Category Name is required
              </div>
            )}
          </div>

          <div className="form-group">
            <label>{t("Category Type")}</label>

            <select
              className="form-control"
              value={category_type}
              onChange={(e) => {
                setCategory_type(e.target.value);
                setIsRecurring("No");
              }}
            >
              <option value="Expense">{t("Expense")}</option>
              <option value="Fee">{t("Fee")}</option>
            </select>
          </div>

          {category_type === "Fee" && (
            <div className="form-group">
              <label>{t("Recurring")}</label>

              <select
                className="form-control"
                value={isRecurring}
                onChange={(e) => setIsRecurring(e.target.value)}
              >
                <option value="No">{t("No")}</option>
                <option value="Yes">{t("Yes")}</option>
              </select>
            </div>
          )}

          <div className="text-left py-3">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-secondary"
            >
              {t("Cancel")}
            </button>

            &nbsp;&nbsp;

            <button
              type="submit"
              className="btn btn-primary"
              disabled={disable}
            >
              {loading ? <ButtonLoading /> : t("Save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditExpenseCategory;